if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if(!document.querySelector(".ajax-cart-disabled")) {
        formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
      }
      config.body = formData;
      
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
          if(document.querySelector(".ajax-cart-disabled")) window.location = "/cart";
          this.cartNotification.renderContents(response);
          openCartDrawer();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


/* ===== USAGS combined wishlist + Klaviyo favorites ===========================
   One visible button (Swym's, untouched) that records to BOTH Swym's wishlist
   and Klaviyo favorites.

   Klaviyo's <klaviyo-favorites-button> is kept on the page but visually hidden,
   and a click on the Swym button is forwarded to it.

   THREE THINGS THE EARLIER VERSION GOT WRONG, each of which failed silently
   while Swym still appeared to work:

   1. SHADOW DOM. Klaviyo's element is a web component and its real button can
      live inside a shadow root, where querySelector('button') cannot reach it.
      The lookup now checks shadowRoot first, then light DOM, then falls back to
      the host element itself.

   2. display:none. Hiding the host that way takes it out of layout, and app
      widgets often skip initialising or refuse interaction when not rendered.
      It is now clipped to a 1px box instead — present and initialised, just
      invisible. pointer-events is off so nobody can tab or tap it by accident;
      programmatic .click() is unaffected by that.

   3. ONE ATTEMPT. The old code did a single setTimeout(0) and gave up. If
      Klaviyo had not finished mounting, the click went nowhere. It now retries
      for about three seconds.

   IF THIS STILL DOESN'T RECORD: some widgets reject synthetic clicks by testing
   event.isTrusted, which no amount of DOM work can fake. The fix then is to
   call Klaviyo's own JS API for adding a favorite rather than clicking a button.
   =========================================================================== */
(function () {
  var SWYM_SEL = '.swym-wishlist-button-bar .swym-add-to-wishlist, .swym-wishlist-button-bar button.swym-button';
  var KL_HOST = 'klaviyo-favorites-button';
  var CLICK_TARGET = 'button, [role="button"], a';

  function klHost() {
    return document.querySelector(KL_HOST);
  }

  function klClickable() {
    var host = klHost();
    if (host) {
      if (host.shadowRoot) {
        var inShadow = host.shadowRoot.querySelector(CLICK_TARGET);
        if (inShadow) return inShadow;
      }
      var inLight = host.querySelector(CLICK_TARGET);
      if (inLight) return inLight;
      return host;
    }
    var widget = document.querySelector('.kl-hub-favorites-widget');
    if (widget) {
      return widget.querySelector(CLICK_TARGET) || widget;
    }
    return null;
  }

  function forward(attempt) {
    var target = klClickable();
    if (target) {
      try {
        target.click();
      } catch (err) {
        try {
          target.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        } catch (err2) {}
      }
      return;
    }
    if (attempt < 20) {
      setTimeout(function () { forward(attempt + 1); }, 150);
    }
  }

  document.addEventListener('click', function (e) {
    var swym = e.target && e.target.closest ? e.target.closest(SWYM_SEL) : null;
    if (!swym) return;
    forward(0);
  }, true);

  function conceal() {
    var host = klHost();
    if (!host || host.getAttribute('data-usags-concealed')) return true;
    host.setAttribute('data-usags-concealed', '1');
    var s = host.style;
    s.position = 'absolute';
    s.width = '1px';
    s.height = '1px';
    s.margin = '-1px';
    s.padding = '0';
    s.border = '0';
    s.overflow = 'hidden';
    s.clip = 'rect(0 0 0 0)';
    s.clipPath = 'inset(50%)';
    s.opacity = '0';
    s.pointerEvents = 'none';
    return true;
  }

  function watch() {
    if (conceal() && klHost()) return;
    var observer = new MutationObserver(function () {
      if (klHost()) {
        conceal();
        observer.disconnect();
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 20000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
